import React from "react";

import { Provider } from "react-redux";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { BasicLoading } from "ZeroRuby";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";

import Chrome from "./Chrome";
import MultipleCompanies from "./MultipleCompanies";
import { createStore } from "./redux";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

const ToastApp = () => {
  const match = useRouteMatch();
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();

  return isLoadingSiteConfig ? (
    <LoadingPage />
  ) : (
    <ScrollToTop>
      <PartnerProvider>
        <Chrome title="Company Selection">
          <Switch>
            <Route path={`${match.url}`} children={<MultipleCompanies />} />
          </Switch>
        </Chrome>
      </PartnerProvider>
    </ScrollToTop>
  );
};

class App extends React.Component {
  constructor() {
    super();
    this.store = createStore();
  }

  render() {
    return (
      <Provider store={this.store}>
        <ToastApp />
      </Provider>
    );
  }
}

export default App;
